<template>
  <div class="login-content">
    <div class="title">{{schoolName || '学校名称'}}</div>
    <div class="form">
      <div class="form-item">
        <div class="form-item-field">
          <label for="">姓名</label>
          <input
            type="text"
            v-model="userNameLocal"
            placeholder="请输入姓名"
            @blur="checkEvtUserName"
          />
        </div>
        <div class="err-msg">{{ errMsgUserName }}</div>
      </div>
      <div class="form-item">
        <div class="form-item-field">
          <label for="">手机号</label>
          <input
            type="tel"
            v-model="phone"
            placeholder="请输入手机号"
            @blur="checkEvtPhone"
          />
        </div>
        <div class="err-msg">{{ errMsgPhone }}</div>
      </div>
      <div class="form-item">
        <div class="form-item-field">
          <label for="">身份证</label>
          <input
            type="text"
            v-model="idCard"
            placeholder="请输入身份证"
            @blur="checkEvtIdCard"
          />
        </div>
        <div class="err-msg">{{ errMsgIdCard }}</div>
      </div>
    </div>
    <div class="footer">
      <div class="btn" @click="onSubmit">登录</div>
    </div>
  </div>
</template>

<script>
import { mobileValide, idCardValide } from "@/utils/valide.js"
import { ref } from "vue"
export default {
  name: "LoginContent",
  props: {
    schoolName: {
      type: String,
      default: "",
    },
    userName: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    //   用户姓名
    const userNameLocal = ref(props.userName)
    const errMsgUserNameLocal = ref("")
    const checkEvtUserName = () => {
      if (userNameLocal.value) {
        errMsgUserNameLocal.value = ""
      } else {
        errMsgUserNameLocal.value = "姓名不能为空！"
      }
    }
    // 手机号
    const phone = ref("")
    const errMsgPhone = ref("")
    const checkEvtPhone = () => {
      if (phone.value) {
        if (mobileValide(phone.value)) {
          errMsgPhone.value = ""
        } else {
          errMsgPhone.value = "手机号格式错误！"
        }
      } else {
        errMsgPhone.value = "手机号不能为空！"
      }
    }
    // 身份证号
    const idCard = ref("")
    const errMsgIdCard = ref("")
    const checkEvtIdCard = () => {
      if (idCard.value) {
        if (idCardValide(idCard.value)) {
          errMsgIdCard.value = ""
        } else {
          errMsgIdCard.value = "身份证格式错误！"
        }
      } else {
        errMsgIdCard.value = "身份证不能为空！"
      }
    }

    // 提交
    const onSubmit = () => {
      if (!userNameLocal.value) {
        errMsgUserNameLocal.value = "姓名不能为空！"
        return
      } else {
        errMsgUserNameLocal.value = ""
      }
      if (errMsgUserNameLocal.value) {
        errMsgUserNameLocal.value = ""
        return
      }

      if (!phone.value) {
        errMsgPhone.value = "手机号不能为空！"
        return
      } else {
        errMsgPhone.value = ""
      }
      if (errMsgPhone.value) {
        errMsgPhone.value = ""
        return
      }

      if (!idCard.value) {
        errMsgIdCard.value = "身份证号不能为空！"
        return
      } else {
        errMsgIdCard.value = ""
      }
      if (errMsgIdCard.value) {
        return
      }

      let params = {
        userName: userNameLocal.value,
        idNumber: idCard.value,
        phone: phone.value,
      }
      emit("login", params)
    }

    return {
      userNameLocal,
      checkEvtUserName,
      errMsgUserNameLocal,
      phone,
      errMsgPhone,
      checkEvtPhone,
      idCard,
      errMsgIdCard,
      checkEvtIdCard,
      onSubmit,
    }
  },
}
</script>

<style lang="less" scoped>
.login-content {
  width: 100%;
  height: calc(100vh - 164px);
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  .title {
    color: #333333;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin: 24px auto;
  }
  .footer {
    margin-top: 64px;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 345px;
      height: 36px;
      color: #fff;
      font-size: 15px;
      font-weight: 400;
      background-color: #4174fd;
      border-radius: 36px;
      margin: 0 auto;
    }
  }
}

.form {
  width: 345px;
  margin: 0 auto;
  .form-item {
    position: relative;
    margin: 24px auto;
    .form-item-field {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      width: 100%;
      height: 36px;
      background: #f2f4fa;
      border-radius: 27px;
      padding: 0 16px;
      label {
        width: 54px;
        color: #999;
      }
      input {
        display: flex;
        align-items: center;
        height: 36px;
        color: #999;
        outline: none;
        border: none;
        background: transparent;
        &::-webkit-input-placeholder {
          color: #ccc;
        }
      }
    }
    .err-msg {
      position: absolute;
      top: 36px;
      left: 70px;
      color: #fe4f54;
      font-size: 14px;
    }
  }
}
</style>
